import axios from "axios";
import { api } from "..";
import { UserDefinedItem, CreateUserDefinedItem, UpdateUserDefinedItem, UserDefinedItemType } from "../../types/domain";

// GET: /api/userdefineditem?itemType=6&sortColumn=0&sortAsc=true
export const getUserDefinedItems = async (
  itemType: UserDefinedItemType = UserDefinedItemType.Project,
  sortColumn: number = 0,
  sortAsc: boolean = true
): Promise<UserDefinedItem[]> => {
  const response = await axios.get(`/api/userdefineditem`, {
    params: {
      itemType,
      sortColumn,
      sortAsc,
    },
  });
  const responseDto = response.data;
  return responseDto.data.map((userDefinedItem: any) => ({
    id: userDefinedItem.id,
    name: userDefinedItem.name,
    itemType: userDefinedItem.itemType,
    lookup: userDefinedItem.lookup,
    dataType: userDefinedItem.dataType,
    categoryId: userDefinedItem.categoryId,
    categoryName: userDefinedItem.categoryName,
    ownerId: userDefinedItem.ownerId,
    ownerName: userDefinedItem.ownerName,
    ownerEnabled: userDefinedItem.ownerEnabled,
    subCounts: {
      userSubCount: userDefinedItem.subCounts.userSubCount,
      groupSubCount: userDefinedItem.subCounts.groupSubCount,
      globalSubCount: userDefinedItem.subCounts.globalSubCount,
      userCatSubCount: userDefinedItem.subCounts.userCatSubCount,
      groupCatSubCount: userDefinedItem.subCounts.groupCatSubCount,
      globalCatSubCount: userDefinedItem.subCounts.globalCatSubCount,
    },
  }));
};

// POST: /api/userdefineditem
export const createUserDefinedItem = async (userDefinedItem: CreateUserDefinedItem): Promise<string> => {
  const response = await api.post('/userdefineditem', userDefinedItem);
  if (response.status === 201) {
    const responseDto = response.data;
    return responseDto.data;
  }
  throw new Error(`Failed to create user defined item. Status: ${response.status}`);
};

// PUT: /api/userdefineditem/{id}
export const updateUserDefinedItem = async (userDefinedItem: UpdateUserDefinedItem): Promise<string> => {
  const response = await api.put(`/userdefineditem/${userDefinedItem.id}`, userDefinedItem);
  if (response.status === 200) {
    const responseDto = response.data;
    return responseDto.data;
  }
  throw new Error(`Failed to update user defined item. Status: ${response.status}`);
};

// DELETE: /api/userdefineditem?itemType=6&id={id}
export const deleteUserDefinedItem = async (
  itemType: UserDefinedItemType,
  id: string
): Promise<void> => {
  const response = await api.delete(`/userdefineditem`, {
    params: {
      itemType,
      id,
    },
  });
  if (response.status !== 204) {
    throw new Error(`Failed to delete user defined item. Status: ${response.status}`);
  }
};